const ITEMS = [
  "Group of Eight",
  "Scholarships",
  "Applications",
  "Student Visas",
  "Campus Life",
  "Independent Guidance",
  "Australian Universities",
  "Student Community",
];

export default function Marquee({ dark = true }) {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y ${dark ? "bg-navy border-navy-border text-cream/70" : "bg-sand border-border text-navy/60"}`}
    >
      <div className="flex w-max animate-marquee py-4">
        {row.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-serif italic text-lg px-8">{item}</span>
            <span className="h-1 w-1 rounded-full bg-gold" />
          </span>
        ))}
      </div>
    </div>
  );
}
